export const gitVersion = {
  'commit': '1470e41',
  'branch': 'Detached: 1470e41a2986b1bd259bb7f15d9f70c33f9e7dbc'
};
